(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/router.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/router.js');
"use strict";


svs.ticketsValidate.logger = svs.core.log.getLogger('tickets-validate');
const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route,
  Switch = _svs$app$ReactRouter.Switch;
const _ReactRouterDOM = ReactRouterDOM,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const baseUrl = svs.core.data.baseUrl;
const _svs$ticketsValidate$ = svs.ticketsValidate.routes,
  VALIDATE = _svs$ticketsValidate$.VALIDATE,
  VALIDATED = _svs$ticketsValidate$.VALIDATED,
  LANDING = _svs$ticketsValidate$.LANDING,
  VALIDATED_BUY_NEW = _svs$ticketsValidate$.VALIDATED_BUY_NEW,
  VALIDATED_BUY_NEW_DEFAULT = _svs$ticketsValidate$.VALIDATED_BUY_NEW_DEFAULT,
  VALIDATED_REDEEM = _svs$ticketsValidate$.VALIDATED_REDEEM,
  ROOT = _svs$ticketsValidate$.ROOT;
const _svs$ticketsValidate$2 = svs.ticketsValidate.pages,
  Validate = _svs$ticketsValidate$2.Validate,
  Validated = _svs$ticketsValidate$2.Validated,
  Landing = _svs$ticketsValidate$2.Landing,
  ValidatedBuyNew = _svs$ticketsValidate$2.ValidatedBuyNew,
  Redeem = _svs$ticketsValidate$2.Redeem,
  Root = _svs$ticketsValidate$2.Root;
const _svs$ticketsValidate$3 = svs.ticketsValidate.components,
  ScrollToTop = _svs$ticketsValidate$3.ScrollToTop,
  InstructionsInfo = _svs$ticketsValidate$3.InstructionsInfo;
const ValidateProvider = svs.ticketsValidate.components.context.ValidateProvider;
const NavigationBack = svs.tur.NavigationBack;
const branding = svs.tickets.data.templateConfig.branding === 'triss' ? 'triss' : 'skrapspel';
const routes = {
  [VALIDATED_BUY_NEW]: {
    text: 'Välj vinstutbetalning',
    path: () => location.pathname.replace('/kop-nya', '')
  },
  [VALIDATED_REDEEM]: {
    text: 'Välj vinstutbetalning',
    path: () => location.pathname.replace('/los-in', '')
  }
};
const Instructions = () => {
  const landingMatch = useRouteMatch(LANDING);
  const validateMatch = useRouteMatch(VALIDATE);
  if (!landingMatch && !validateMatch) return null;
  return React.createElement(InstructionsInfo, {
    showStepByStep: landingMatch.isExact || validateMatch.isExact
  });
};
const Router = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(ValidateProvider, null, React.createElement(ScrollToTop, null), React.createElement(NavigationBack, {
  brand: branding,
  routes: routes
}), React.createElement(Switch, null, React.createElement(Route, {
  component: Root,
  exact: true,
  path: ROOT
}), React.createElement(Route, {
  component: ValidatedBuyNew,
  exact: true,
  path: VALIDATED_BUY_NEW
}), React.createElement(Route, {
  component: ValidatedBuyNew,
  exact: true,
  path: VALIDATED_BUY_NEW_DEFAULT
}), React.createElement(Route, {
  component: Redeem,
  exact: true,
  path: VALIDATED_REDEEM
}), React.createElement(Route, {
  component: Landing,
  exact: true,
  path: LANDING
}), React.createElement(Route, {
  component: Validate,
  exact: true,
  path: VALIDATE
}), React.createElement(Route, {
  component: Validated,
  exact: true,
  path: VALIDATED
})), React.createElement(Instructions, null)));
const container = document.getElementById('reactContainer');
container && ReactDOM.render(React.createElement(Router, null), container);

 })(window);